/* eslint-disable */
const routes = [
  {
    path: "/",
    name: "home",
    component: () => import(/* webpackChunkName: "home" */ "../views/Home.vue"),
    meta: {
      title: "سکوی تامین مالی جمعی و سرمایه گذاری آتیه ایرانیان",
    },
  },
  {
    path: "/Home",
    redirect: "/",
    meta: {
      private: true,
    },
  },
  {
    path: "/Atiya",
    name: "atiya",
    component: () =>
      import(/* webpackChunkName: "atiya" */ "../views/Atiya.vue"),
    props: true,
    meta: {
      title: "تامین مالی جمعی آتیه ایرانیان | درباره آتیا",
    },
  },
  {
    path: "/L/:id",
    name: "landing",
    component: () =>
      import(/* webpackChunkName: "landing" */ "../views/Landing.vue"),
    props: true,
    meta: {
      title: "تامین مالی جمعی آتیه ایرانیان | آتیا لندینگ",
      private: true,
    },
  },
  {
    path: "/Project/:id",
    name: "project",
    component: () =>
      import(/* webpackChunkName: "project" */ "../views/Project.vue"),
    props: true,
    meta: {
      title: "تامین مالی جمعی آتیه ایرانیان | جزئیات طرح",
      private: true,
    },
  },
  {
    path: "/Projects",
    name: "projects",
    component: () =>
      import(/* webpackChunkName: "projects" */ "../views/Projects.vue"),
    meta: {
      title: "تامین مالی جمعی آتیه ایرانیان | طرح‌ها",
    },
  },
  {
    path: "/Contact",
    name: "contact",
    component: () =>
      import(/* webpackChunkName: "contact" */ "../views/Contact.vue"),
    meta: {
      title: "تامین مالی جمعی آتیه ایرانیان | تماس باما",
    },
  },
  {
    path: "/Social",
    name: "social",
    component: () =>
      import(/* webpackChunkName: "social" */ "../views/Social.vue"),
    meta: {
      title: "تامین مالی جمعی آتیه ایرانیان | شبکه‌های اجتماعی",
    },
  },
  {
    path: "/Newsletter",
    name: "newsletter",
    component: () =>
      import(/* webpackChunkName: "newsletter" */ "../views/Newsletter.vue"),
    meta: {
      title: "تامین مالی جمعی آتیه ایرانیان | خبرنامه",
    },
  },
  {
    path: "/Partnership",
    name: "partnership",
    component: () =>
      import(/* webpackChunkName: "partnership" */ "../views/Partnership.vue"),
    meta: {
      title: "تامین مالی جمعی آتیه ایرانیان | تقاضای همکاری",
    },
  },
  {
    path: "/Financing",
    name: "financing",
    component: () =>
      import(/* webpackChunkName: "financing" */ "../views/Financing.vue"),
    meta: {
      title: "تامین مالی جمعی آتیه ایرانیان | درخواست تأمین مالی",
    },
  },
  {
    path: "/Funding",
    name: "funding",
    component: () =>
      import(/* webpackChunkName: "funding" */ "../views/Funding.vue"),
    meta: {
      title: "تامین مالی جمعی آتیه ایرانیان | ثبت طرح و تأمین سرمایه",
    },
  },
  {
    path: "/Introduction",
    name: "introduction",
    component: () =>
      import(
        /* webpackChunkName: "introduction" */ "../views/Introduction.vue"
      ),
    meta: {
      title: "تامین مالی جمعی آتیه ایرانیان | آشنایی با سکوی آتیا ایرانیان",
    },
  },
  {
    path: "/Investment",
    name: "investment",
    component: () =>
      import(/* webpackChunkName: "investment" */ "../views/Investment.vue"),
    meta: {
      title: "تامین مالی جمعی آتیه ایرانیان | ثبت نام و سرمایه گذاری",
    },
  },
  {
    path: "/News",
    name: "news",
    component: () => import(/* webpackChunkName: "news" */ "../views/News.vue"),
    meta: {
      title: "تامین مالی جمعی آتیه ایرانیان | خبرنامه",
      private: true,
    },
  },
  {
    path: "/Blog/:page",
    alias: ["/Blog/:page/:category"],
    name: "blog",
    component: () => import(/* webpackChunkName: "blog" */ "../views/Blog.vue"),
    props: true,
    meta: {
      title: "تامین مالی جمعی آتیه ایرانیان | بلاگ",
      private: true,
    },
  },
  {
    path: "/Post/:id",
    name: "post",
    component: () => import(/* webpackChunkName: "post" */ "../views/Post.vue"),
    props: true,
    meta: {
      title: "تامین مالی جمعی آتیه ایرانیان | پست بلاگ",
      private: true,
    },
  },
  {
    path: "/Knowledge",
    name: "knowledge",
    component: () =>
      import(/* webpackChunkName: "knowledge" */ "../views/Knowledge.vue"),
    meta: {
      title: "تامین مالی جمعی آتیه ایرانیان | دانشنامه",
      private: true,
    },
  },
  {
    path: "/Risk",
    name: "risk",
    component: () =>
      import(/* webpackChunkName: "knowledge" */ "../views/Risk.vue"),
    meta: {
      title: "تامین مالی جمعی آتیه ایرانیان | بیانیه ریسک",
      private: true,
    },
  },
  {
    path: "/vc",
    redirect: "/Project/e3132914-2c24-4ef2-85a2-daf4fe3e7a8c",
    meta: {
      private: true,
    },
  },
  {
    path: "/s/:id",
    component: () =>
      import(/* webpackChunkName: "redirect" */ "../views/Redirect.vue"),
    props: true,
    meta: {
      private: true,
    },
  },
  {
    path: "/:pathMatch(.*)*",
    name: "notfound",
    component: () =>
      import(/* webpackChunkName: "notfound" */ "../components/NotFound.vue"),
    meta: {
      title: "تامین مالی جمعی آتیه ایرانیان | صفحه یافت نشد",
      private: true,
    },
  },
];

export default routes;
